import { empresaGuard } from 'app/core/auth/guards/empresa.guard';
import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { ClienteScopeGuard } from 'app/core/auth/guards/clienteScope.guard';
import { StaffAuthGuard } from 'app/core/auth/guards/staffAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmpComponent } from './modules/adm/emp/emp.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // emp
 //   {path: 'emp', component: EmpComponent},

    // Redirect empty path to '/dashboards/project'
    //{path: '', pathMatch : 'full', redirectTo: 'dashboards/project'},
  //  {path: '', pathMatch : 'full', redirectTo: 'dashboards/login'},

    // Redirect signed-in user to the '/dashboards/project'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
 //   {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard/project'},

    // Auth routes for guests






    // Admin routes
    {
        path: '',
        //canActivate: [AuthGuard],
        //canActivateChild: [AuthGuard],
        canActivateChild: [ClienteScopeGuard, StaffAuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // Autenticación
            {path: 'aut', children: [
                {path: 'login', loadChildren: () => import('app/modules/aut/login/login.routes')},
                {path: 'logout', loadChildren: () => import('app/modules/aut/logout/logout.routes')},
                {path: 'emp', loadChildren: () => import('app/modules/adm/emp/emp.routes')},
                {path: 'ecomm', loadChildren: () => import('app/modules/admin/apps/ecommerce/ecommerce.routes')},
                {path: 'finance', loadChildren: () => import('app/modules/admin/dashboards/finance/finance.routes')},
                {path: 'crypto', loadChildren: () => import('app/modules/admin/dashboards/crypto/crypto.routes')},
            ]},
            // Adm
            {path: 'adm', children: [
                {path: 'dsh', loadChildren: () => import('app/modules/adm/dsh/dsh.routes')},
                {path: 'dom', loadChildren: () => import('app/modules/adm/dom/dom.routes')},
                {path: 'usr', loadChildren: () => import('app/modules/adm/usr/usr.routes')},
                {path: 'emp', loadChildren: () => import('app/modules/adm/emp/emp.routes')},
                {path: 'acc', loadChildren: () => import('app/modules/adm/acc/acc.routes')},
                // Control de Acceso del usuario DOM (holding). Por ahora clon de 'acc'.
                {path: 'acc-hol', loadChildren: () => import('app/modules/adm/acc-hol/acc-hol.routes')},
                {path: 'inv', loadChildren: () => import('app/modules/admin/apps/ecommerce/ecommerce.routes')},
                {path: 'finance', loadChildren: () => import('app/modules/admin/dashboards/finance/finance.routes')},
                {path: 'crypto', loadChildren: () => import('app/modules/admin/dashboards/crypto/crypto.routes')},
            ]},
            // Finanzas (conceptos)
            {path: 'fin', children: [
                {path: 'rsm', loadComponent: () => import('app/modules/fin/rsm/rsm.component').then(m => m.RsmComponent)},
                {path: 'edr', loadComponent: () => import('app/modules/fin/edr/edr.component').then(m => m.EdrComponent)},
                {path: 'fco', loadComponent: () => import('app/modules/fin/fco/fco.component').then(m => m.FcoComponent)},
                {path: 'cta', loadComponent: () => import('app/modules/fin/cta/cta.component').then(m => m.CtaComponent)},
                {path: 'matriz', loadComponent: () => import('app/modules/fin/matriz/matriz.component').then(m => m.MatrizComponent)},
                {path: 'mtx-dd', loadComponent: () => import('app/modules/fin/mtx-dd/mtx-dd.component').then(m => m.MtxDdComponent)},
                {path: 'mtx-dd-his', loadComponent: () => import('app/modules/fin/mtx-dd-his/mtx-dd-his.component').then(m => m.MtxDdHisComponent)},
                {path: 'cfw-his', loadComponent: () => import('app/modules/fin/mtx-dd-his-ext/mtx-dd-his-ext.component').then(m => m.MtxDdHisExtComponent)},
                {path: 'mtx-proy', loadComponent: () => import('app/modules/fin/mtx-proy/mtx-proy.component').then(m => m.MtxProyComponent)},
                {path: 'cfw-pro', loadComponent: () => import('app/modules/fin/cfw-esc/cfw-esc.component').then(m => m.CfwEscComponent)},
                {path: 'fev', loadComponent: () => import('app/modules/fin/fev/fev.component').then(m => m.FevComponent)},
                {path: 'fre', loadComponent: () => import('app/modules/fin/fre/fre.component').then(m => m.FreComponent)},
                {path: 'fsu', loadComponent: () => import('app/modules/fin/fsu/fsu.component').then(m => m.FsuComponent)},
                {path: 'fes', loadComponent: () => import('app/modules/fin/fes/fes.component').then(m => m.FesComponent)},
                {path: 'fsr', loadComponent: () => import('app/modules/fin/fsr/fsr.component').then(m => m.FsrComponent)},
            ]},
            // Bancos
            {path: 'ban', children: [
                {path: 'oba', loadChildren: () => import('app/modules/ban/oba/oba.routes')},
                {path: 'ctb', loadChildren: () => import('app/modules/ban/ctb/ctb.routes')},
                {path: 'ctt', loadChildren: () => import('app/modules/ban/ctt/ctt.routes')},
                {path: 'mba', loadChildren: () => import('app/modules/ban/mba/mba.routes')},
                {path: 'est-act', loadChildren: () => import('app/modules/ban/icb/est/act/cba.routes')},
                {path: 'est-his', loadChildren: () => import('app/modules/ban/icb/est/act/cba.routes')},
                {path: 'san-his', loadChildren: () => import('app/modules/ban/icb/san/his/his.routes')},
                {path: 'san-act', loadChildren: () => import('app/modules/ban/icb/san/his/his.routes')},
                {path: 'cba', loadChildren: () => import('app/modules/ban/cba/cba.routes')},
                {path: 'ctl', loadChildren: () => import('app/modules/ban/ctl/ctl.routes')},
                {path: 'mbacba', loadChildren: () => import('app/modules/ban/mbacba/mbacba.routes')},
                {path: 'cia', loadChildren: () => import('app/modules/ban/cia/cia.routes')},
                {path: 'dbf01', loadChildren: () => import('app/modules/ban/dbf/dbf01/dbf01.routes')},
                {path: 'dbf02', loadChildren: () => import('app/modules/ban/dbf/dbf02/dbf02.routes')},
                {path: 'fin01', loadChildren: () => import('app/modules/ban/rep/fin01/fin01.routes')},
                //{path: 'dbf02', loadChildren: () => import('app/modules/ban/dbf/dbf02/dbf02.routes')},
            ]},
            // Caja IA
            {path: 'caj', children: [
                {path: 'res', loadChildren: () => import('app/modules/caj/caj-placeholder.routes')},
                {path: 'flp', loadChildren: () => import('app/modules/caj/caj-placeholder.routes')},
                {path: 'cob', loadChildren: () => import('app/modules/caj/caj-placeholder.routes')},
                {path: 'pag', loadChildren: () => import('app/modules/caj/caj-placeholder.routes')},
                {path: 'rec', loadChildren: () => import('app/modules/caj/caj-placeholder.routes')},
                {path: 'sim', loadChildren: () => import('app/modules/caj/caj-placeholder.routes')},
                {path: 'ale', loadChildren: () => import('app/modules/caj/caj-placeholder.routes')},
                {path: 'cfg', loadChildren: () => import('app/modules/caj/caj-placeholder.routes')},
                {path: 'tin', loadChildren: () => import('app/modules/caj/tin/tin.routes')},
                {path: 'ter', loadChildren: () => import('app/modules/caj/ter/ter.routes')},
                {path: 'egr', loadChildren: () => import('app/modules/caj/egr/egr.routes')},
                {path: 'din', loadChildren: () => import('app/modules/caj/din/din.routes')},
                {path: 'deg', loadChildren: () => import('app/modules/caj/deg/deg.routes')},
            ]},
            // Flujo de Caja IA
            {
                path: 'cfw',
                loadChildren: () =>
                    import('./modules/cfw/cfw.module').then(m => m.CfwModule),
            },
            // Ger
            {path: 'ger', children: [
                {path: 'dbg', loadChildren: () => import('app/modules/ger/dbg/dbg.routes')},
                // Tablero consolidado del dominio (usuario DOM → botón Dominio → "Todas las Empresas")
                {path: 'dbg-dom', loadChildren: () => import('app/modules/ger/dbg-dom/dbg-dom.routes')},
                // Dashboard Holding (modo dominio: botón Dominio → "Todas las Empresas")
                {path: 'dbg-hol', loadChildren: () => import('app/modules/ger/dbg-hol/hol.routes')},
                {path: 'emp', loadChildren: () => import('app/modules/ger/emp/emp.routes')},
              //  {path: 'tbc', loadChildren: () => import('app/modules/ger/tbc/tbc.routes')},
                {path: 'finance', loadChildren: () => import('app/modules/admin/dashboards/finance/finance.routes')},
                {path: 'crypto', loadChildren: () => import('app/modules/admin/dashboards/crypto/crypto.routes')},
            ]},
            // Crm
            {path: 'crm', children: [
                {path: 'finance', loadChildren: () => import('app/modules/admin/dashboards/finance/finance.routes')},
                {path: 'crypto', loadChildren: () => import('app/modules/admin/dashboards/crypto/crypto.routes')},
            ]},

            // Clientes (clon standalone de vta/vta03)
            {path: 'clientes', loadChildren: () => import('app/modules/clientes/clientes.routes')},

            // Vta
            {path: 'vta', children: [
                {path: 'inv', loadChildren: () => import('app/modules/admin/apps/ecommerce/ecommerce.routes')},
                {path: 'ven', loadChildren: () => import('app/modules/vta/ven/ven.routes')},
                {path: 'cli', loadChildren: () => import('app/modules/vta/cli/cli.routes')},
                {path: 'efa', loadChildren: () => import('app/modules/vta/efa/efa.routes')},
                {path: 'efe', loadChildren: () => import('app/modules/vta/efe/efe.routes')},
                {path: 'ecr', loadChildren: () => import('app/modules/vta/ecr/ecr.routes')},
                {path: 'ede', loadChildren: () => import('app/modules/vta/ede/ede.routes')},
                {path: 'xfa', loadChildren: () => import('app/modules/vta/xfa/xfa.routes')},
                {path: 'pag', loadChildren: () => import('app/modules/vta/pag/pag.routes')},
                {path: 'cob', loadChildren: () => import('app/modules/vta/cob/cob.routes')},
                {path: 'vta01', loadChildren: () => import('app/modules/vta/rep/vta01/vta01.routes')},
                {path: 'vta02', loadChildren: () => import('app/modules/vta/rep/vta02/vta02.routes')},
                {path: 'vta03', loadChildren: () => import('app/modules/vta/rep/vta03/vta03.routes')},
                {path: 'v05', loadChildren: () => import('app/modules/vta/rep/r05/r05.routes')},
                {path: 'dbv01', loadChildren: () => import('app/modules/vta/dbv/dbv01/dbv01.routes')},
                {path: 'dbv02', loadChildren: () => import('app/modules/vta/dbv/dbv02/dbv02.routes')},
                {path: 'imp', loadChildren: () => import('app/modules/vta/imp/imp.routes')},
                {path: 'tfa', loadChildren: () => import('app/modules/vta/tfa/tfa.routes')},
                {path: 'tfe', loadChildren: () => import('app/modules/vta/tfe/tfe.routes')},
                /* {path: 'doc', loadChildren: () => import('app/modules/cmp/doc/doc.routes')},

                {path: 'fnc', loadChildren: () => import('app/modules/cmp/fnc/fnc.routes')},

                {path: 'rpc01', loadChildren: () => import('app/modules/cmp/reports/r01/r01.routes')},
                {path: 'rpc02', loadChildren: () => import('app/modules/cmp/reports/r02/r02.routes')},
                {path: 'rpc03', loadChildren: () => import('app/modules/cmp/reports/r03/r03.routes')},
                {path: 'rpc04', loadChildren: () => import('app/modules/cmp/reports/r04/r04.routes')},
                {path: 'rpc05', loadChildren: () => import('app/modules/cmp/reports/r05/r05.routes')},
                {path: 'finance', loadChildren: () => import('app/modules/admin/dashboards/finance/finance.routes')},
                {path: 'crypto', loadChildren: () => import('app/modules/admin/dashboards/crypto/crypto.routes')}, */
            ]},

            // Cmp
            {path: 'cmp', children: [
                {path: 'prv', loadChildren: () => import('app/modules/cmp/prv/prv.routes')},
                {path: 'fap', loadChildren: () => import('app/modules/cmp/fap/fap.routes')},
                {path: 'fep', loadChildren: () => import('app/modules/cmp/fep/fep.routes')},
                {path: 'ncp', loadChildren: () => import('app/modules/cmp/ncp/ncp.routes')},
                {path: 'ndp', loadChildren: () => import('app/modules/cmp/ndp/ndp.routes')},
                {path: 'pay', loadChildren: () => import('app/modules/cmp/pay/pay.routes')},
                {path: 'pag', loadChildren: () => import('app/modules/cmp/pag/pag.routes')},
                {path: 'dbc01', loadChildren: () => import('app/modules/cmp/dbc/dbc01/dbc01.routes')},
                {path: 'dbc02', loadChildren: () => import('app/modules/cmp/dbc/dbc02/dbc02.routes')},

                {path: 'cmp01', loadChildren: () => import('app/modules/cmp/rep/cmp01/cmp01.routes')},
                {path: 'cmp02', loadChildren: () => import('app/modules/cmp/rep/cmp02/cmp02.routes')},
                {path: 'cmp03', loadChildren: () => import('app/modules/cmp/rep/cmp03/cmp03.routes')},
                //{path: 'cmp04', loadChildren: () => import('app/modules/cmp/rep/cmp04/cmp04.routes')},
                //{path: 'cmp03', loadChildren: () => import('app/modules/cmp/rep/cmp03/cmp03.routes')},
               /*  {path: 'rpc02', loadChildren: () => import('app/modules/cmp/reports/r02/r02.routes')},
                {path: 'rpc03', loadChildren: () => import('app/modules/cmp/reports/r03/r03.routes')},
                {path: 'rpc04', loadChildren: () => import('app/modules/cmp/reports/r04/r04.routes')},
                {path: 'rpc05', loadChildren: () => import('app/modules/cmp/reports/r05/r05.routes')}, */
                {path: 'finance', loadChildren: () => import('app/modules/admin/dashboards/finance/finance.routes')},
                {path: 'crypto', loadChildren: () => import('app/modules/admin/dashboards/crypto/crypto.routes')},
            ]},

            // Hon (Honorarios)
            {path: 'hon', children: [
                {path: 'emi', loadChildren: () => import('app/modules/hon/emi/emi.routes')},
                {path: 'bhe', loadChildren: () => import('app/modules/hon/bhe/bhe.routes')},
                {path: 'pae', loadChildren: () => import('app/modules/hon/pae/pae.routes')},
                {path: 'pge', loadChildren: () => import('app/modules/hon/pge/pge.routes')},
            ]},

            // Ofv (Oficina Virtual) — piloto restringido a kemp=6, ver
            // ClassyLayoutComponent._filterNavigationForUser
            {path: 'ofv', children: [
                {path: 'home', loadChildren: () => import('app/modules/ofv/home/home.routes')},
                {path: 'fam', loadChildren: () => import('app/modules/ofv/fam/fam.routes')},
                {path: 'sub', loadChildren: () => import('app/modules/ofv/sub/sub.routes')},
                {path: 'itm', loadChildren: () => import('app/modules/ofv/itm/itm.routes')},
                {path: 'clo', loadChildren: () => import('app/modules/ofv/clo/clo.routes')},
                {path: 'ctc', loadChildren: () => import('app/modules/ofv/ctc/ctc.routes')},
                {path: 'ctt', loadChildren: () => import('app/modules/ofv/ctt/ctt.routes')},
                {path: 'ods', loadChildren: () => import('app/modules/ofv/ods/ods.routes')},
                {path: 'cob', loadChildren: () => import('app/modules/ofv/cob/cob.routes')},
                {path: 'pas', loadChildren: () => import('app/modules/ofv/pas/pas.routes')},
                {path: 'vta04', loadChildren: () => import('app/modules/ofv/vta04/vta04.routes')},
                {path: 'vta09', loadChildren: () => import('app/modules/ofv/vta09/vta09.routes')},
            ]},

            // Sii
            {path: 'sii', children: [
                {path: 'rcv', loadChildren: () => import('app/modules/sii/rcv/rcv.routes')},
                {path: 'rdm', loadChildren: () => import('app/modules/cmp/rep/rdm/rdm.routes')},
                // Impuestos (IVA + retención de honorarios). Antes sii/iva: se
                // mantiene como redirección para enlaces/marcadores viejos.
                {path: 'imp', loadChildren: () => import('app/modules/sii/iva/iva.routes')},
                {path: 'iva', pathMatch: 'full', redirectTo: 'imp'},
                {path: 'cmp04', loadChildren: () => import('app/modules/sii/cmp04/cmp04.routes')},
            ]},

            // Networking — redes empresariales para hacer negocios; exclusivo empresa 164 (menú oculto en classy + guard de ruta)
            {path: 'nwk', canActivate: [empresaGuard([164])], children: [
                {path: 'usg', loadChildren: () => import('app/modules/nwk/usg/usg.routes')},
                {path: 'aec', loadChildren: () => import('app/modules/nwk/aec/aec.routes')},
                {path: 'mem', loadChildren: () => import('app/modules/nwk/mem/mem.routes')},
                {path: 'bem', loadChildren: () => import('app/modules/nwk/bem/bem.routes')},
                {path: 'cat', loadChildren: () => import('app/modules/nwk/cat/cat.routes')},
            ]},

            // Mor
            {path: 'mor', children: [
                {path: 'act', loadChildren: () => import('app/modules/mor/act/act.routes')},
                {path: 'iba', loadChildren: () => import('app/modules/mor/iba/iba.routes')},
                {path: 'cli', loadChildren: () => import('app/modules/mor/cli/cli.routes')},
                {path: 'mfa', loadChildren: () => import('app/modules/mor/mfa/mfa.routes')},
            ]},


            // Cfg
            {path: 'cfg', children: [
                {path: 'reg', loadChildren: () => import('app/modules/cfg/reg/reg.routes')},
                {path: 'com', loadChildren: () => import('app/modules/cfg/com/com.routes')},
                {path: 'cco', loadChildren: () => import('app/modules/cfg/cco/cco.routes')},
                {path: 'par', loadChildren: () => import('app/modules/cfg/par/par.routes')},
                {path: 'pms', loadChildren: () => import('app/modules/cfg/pms/pms.routes')},
                {path: 'finance', loadChildren: () => import('app/modules/admin/dashboards/finance/finance.routes')},
                {path: 'crypto', loadChildren: () => import('app/modules/admin/dashboards/crypto/crypto.routes')},
            ]},

            // Dashboards
            {path: 'dashboards', children: [
                {path: 'project', loadChildren: () => import('app/modules/admin/dashboards/project/project.routes')},
                {path: 'analytics', loadChildren: () => import('app/modules/admin/dashboards/analytics/analytics.routes')},
                {path: 'finance', loadChildren: () => import('app/modules/admin/dashboards/finance/finance.routes')},
                {path: 'crypto', loadChildren: () => import('app/modules/admin/dashboards/crypto/crypto.routes')},
            ]},

            // Apps
            {path: 'apps', children: [
                {path: 'academy', loadChildren: () => import('app/modules/admin/apps/academy/academy.routes')},
                {path: 'chat', loadChildren: () => import('app/modules/admin/apps/chat/chat.routes')},
                {path: 'contacts', loadChildren: () => import('app/modules/admin/apps/contacts/contacts.routes')},
                {path: 'file-manager', loadChildren: () => import('app/modules/admin/apps/file-manager/file-manager.routes')},
                {path: 'help-center', loadChildren: () => import('app/modules/admin/apps/help-center/help-center.routes')},
                {path: 'mailbox', loadChildren: () => import('app/modules/admin/apps/mailbox/mailbox.routes')},
                {path: 'notes', loadChildren: () => import('app/modules/admin/apps/notes/notes.routes')},
                {path: 'scrumboard', loadChildren: () => import('app/modules/admin/apps/scrumboard/scrumboard.routes')},
                {path: 'tasks', loadChildren: () => import('app/modules/admin/apps/tasks/tasks.routes')},
            ]},

            // Pages
            {path: 'pages', children: [

                // Activities
                {path: 'activities', loadChildren: () => import('app/modules/admin/pages/activities/activities.routes')},

                // Authentication
                {path: 'authentication', loadChildren: () => import('app/modules/admin/pages/authentication/authentication.routes')},

                // Coming Soon
                {path: 'coming-soon', loadChildren: () => import('app/modules/admin/pages/coming-soon/coming-soon.routes')},

                // Error
                {path: 'error', children: [
                    {path: '404', loadChildren: () => import('app/modules/admin/pages/error/error-404/error-404.routes')},
                    {path: '500', loadChildren: () => import('app/modules/admin/pages/error/error-500/error-500.routes')}
                ]},

                // Invoice
                {path: 'invoice', children: [
                    {path: 'printable', children: [
                        {path: 'compact', loadChildren: () => import('app/modules/admin/pages/invoice/printable/compact/compact.routes')},
                        {path: 'modern', loadChildren: () => import('app/modules/admin/pages/invoice/printable/modern/modern.routes')}
                    ]}
                ]},

                // Maintenance
                {path: 'maintenance', loadChildren: () => import('app/modules/admin/pages/maintenance/maintenance.routes')},

               /*  // Pricing
                {path: 'pricing', children: [
                    {path: 'modern', loadChildren: () => import('app/modules/admin/pages/pricing/modern/modern.routes')},
                    {path: 'simple', loadChildren: () => import('app/modules/admin/pages/pricing/simple/simple.routes')},
                    {path: 'single', loadChildren: () => import('app/modules/admin/pages/pricing/single/single.routes')},
                    {path: 'table', loadChildren: () => import('app/modules/admin/pages/pricing/table/table.routes')}
                ]}, */

                // Profile
                {path: 'profile', loadChildren: () => import('app/modules/admin/pages/profile/profile.routes')},

                // Settings
                {path: 'settings', loadChildren: () => import('app/modules/admin/pages/settings/settings.routes')},
            ]},

            // User Interface
            {path: 'ui', children: [

                // Material Components
                {path: 'material-components', loadChildren: () => import('app/modules/admin/ui/material-components/material-components.routes')},

                // Fuse Components
                {path: 'fuse-components', loadChildren: () => import('app/modules/admin/ui/fuse-components/fuse-components.routes')},

                // Other Components
                {path: 'other-components', loadChildren: () => import('app/modules/admin/ui/other-components/other-components.routes')},

                // TailwindCSS
                {path: 'tailwindcss', loadChildren: () => import('app/modules/admin/ui/tailwindcss/tailwindcss.routes')},

                // Advanced Search
                {path: 'advanced-search', loadChildren: () => import('app/modules/admin/ui/advanced-search/advanced-search.routes')},

                // Animations
                {path: 'animations', loadChildren: () => import('app/modules/admin/ui/animations/animations.routes')},

                 // Cards
                {path: 'cards', loadChildren: () => import('app/modules/admin/ui/cards/cards.routes')},

                // Colors
                {path: 'colors', loadChildren: () => import('app/modules/admin/ui/colors/colors.routes')},

                // Confirmation Dialog
                {path: 'confirmation-dialog', loadChildren: () => import('app/modules/admin/ui/confirmation-dialog/confirmation-dialog.routes')},

                // Datatable
                {path: 'datatable', loadChildren: () => import('app/modules/admin/ui/datatable/datatable.routes')},

                // Forms
                {path: 'forms', loadChildren: () => import('app/modules/admin/ui/forms/forms.routes')},

                // Icons
                {path: 'icons', loadChildren: () => import('app/modules/admin/ui/icons/icons.routes')},

                // Page Layouts
                {path: 'page-layouts', loadChildren: () => import('app/modules/admin/ui/page-layouts/page-layouts.routes')},

                // Typography
                {path: 'typography', loadChildren: () => import('app/modules/admin/ui/typography/typography.routes')}
            ]},

            // Documentation
            {path: 'pags', children: [

                // Changelog
                {path: 'changelog', loadChildren: () => import('app/modules/admin/docs/changelog/changelog.routes')},

                // Guides
                {path: 'guides', loadChildren: () => import('app/modules/admin/docs/guides/guides.routes')}
            ]},

            // 404 & Catch all
            {path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/admin/pages/error/error-404/error-404.routes')},

            //{path: '**', redirectTo: '404-not-found'},
            {path: '**', redirectTo: 'home'},

            {path: 'home', pathMatch: 'full', loadChildren: () => import('app/modules/aut/login/login.routes')},
        ]
    }
];
